import React from "react";
import PropTypes from "prop-types";

const SendLogo = ({color= "#2F39D3"}) => {
  return (
    <svg
      width="40"
      height="36" 
      viewBox="0 0 40 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_3013_7901)">
        <rect x="2" y="1" width="36" height="36" rx="8" fill={color} />
        <rect
          x="2.5"
          y="1.5"
          width="35"
          height="35"
          rx="7.5"
          stroke={color}
        />
        <path
          d="M18.7495 20.2501L27.4995 11.5001M18.8558 20.5235L21.0459 26.1552C21.2389 26.6513 21.3353 26.8994 21.4743 26.9718C21.5948 27.0346 21.7384 27.0347 21.859 26.972C21.998 26.8998 22.0948 26.6518 22.2883 26.1559L27.7803 12.0828C27.955 11.6352 28.0423 11.4113 27.9945 11.2683C27.953 11.1441 27.8556 11.0466 27.7314 11.0051C27.5883 10.9574 27.3645 11.0447 26.9169 11.2194L12.8437 16.7113C12.3478 16.9049 12.0999 17.0016 12.0276 17.1407C11.965 17.2613 11.9651 17.4048 12.0279 17.5253C12.1003 17.6643 12.3483 17.7608 12.8445 17.9537L18.4761 20.1438C18.5768 20.183 18.6272 20.2026 18.6696 20.2328C18.7072 20.2596 18.74 20.2925 18.7668 20.3301C18.7971 20.3725 18.8167 20.4228 18.8558 20.5235Z"
          stroke="white"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_3013_7901"
          x="0"
          y="0"
          width="40"
          height="40"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3013_7901"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3013_7901"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

SendLogo.propTypes = {
  color: PropTypes.string,
};
export default SendLogo;